// extracted by mini-css-extract-plugin
module.exports = {"emptyBlock":"NoOptions_emptyBlock__OXbuk"};